import {Component, OnInit} from '@angular/core';

import {SurveyCreatorModel} from "survey-creator-core";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {FetchSurveyDetails} from "../../core/questionnaires.selectors";
import {Subject, takeUntil} from "rxjs";
import {
  EditSurveyDataForSurveyConfigRequest,
  FetchSurveyDetailsByIdRequest
} from "../../core/questionnaires.actions";
import {QuestionnaireConstant} from "../../constants/questionnaire.enum";
import {CommonService} from "../../../../shared/services/common.service";

@Component({
  selector: 'app-create-survey-form-screen',
  templateUrl: './create-survey-form-screen.component.html',
  styleUrls: ['./create-survey-form-screen.component.css']
})
export class CreateSurveyFormScreenComponent implements OnInit {

  creatorOptions = {
    showLogicTab: false,
    isAutoSave: true,
    showJSONEditorTab: false,
    allowModifyPages: false,
    questionTypes: ["text", "checkbox", "dropdown", "comment", "tagbox"],
    showThemeTab: true,
    showSurveyTitle: false,
  };
  surveyCreatorModel: SurveyCreatorModel;
  surveyDetails: any = {}
  private mode = QuestionnaireConstant.add;
  private surveyId: string = ''
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private store: Store,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.surveyCreatorModel = new SurveyCreatorModel(this.creatorOptions);

    this.route.paramMap.pipe(takeUntil(this.onDestroy))
      .subscribe((params: any) => {
        if (params?.params?.questionnaireId) {
          this.surveyId = params?.params?.questionnaireId;
          this.store.dispatch(FetchSurveyDetailsByIdRequest({payload: {surveyId: params?.params?.questionnaireId}}));
        }
      });

    this.store.select(FetchSurveyDetails)
      .pipe(takeUntil(this.onDestroy)).subscribe(surveyDetails => {
      this.surveyDetails = surveyDetails;

      if (this.router.url.includes(QuestionnaireConstant.edit)) {
        this.mode = QuestionnaireConstant.edit;
      }
      if (Object.keys(surveyDetails).length > 0) {
        if (surveyDetails.config) {
          const creator = new SurveyCreatorModel(this.creatorOptions);
          creator.text = JSON.stringify(surveyDetails.config[0])
          this.surveyCreatorModel = creator;
        } else {
          const creator = new SurveyCreatorModel(this.creatorOptions);
          creator.addPage();
          this.surveyCreatorModel = creator;
        }
      }
    })

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }
        const prevUrlParams = this.commonService.urlParams.getValue();

        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  saveSurvey(navigate: boolean) {
    const updatedElements = this.surveyCreatorModel.JSON.pages[0].elements.map(item => {
      if (item.inputType === 'url') {
        return {
          ...item,
          validators: [
            {
              type: "regex",
              regex: "^(?:http|https)://",
              text: "Please provide a valid url",
            },
          ],
        }
      } else {
        return {
          ...item
        }
      }
    })
    const updatedSurveyData = [
      {
        name: 'page1',
        elements: updatedElements,
        checkErrorsMode: "onValueChanged",
      }
    ];

    this.store.dispatch(EditSurveyDataForSurveyConfigRequest({
      payload: {
        surveyId: this.surveyId,
        config: updatedSurveyData,
        status: QuestionnaireConstant.draftStatus,
        mode: this.mode,
        navigate: navigate
      }
    }))
  }

  backButtonClicked() {
    this.router.navigate([`/stanford-admin/questionnaires/edit/create-questionnaire-schedule/${this.surveyId}`])
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
